import pathToRegexp from 'path-to-regexp';

export default function replaceChannelParameters(
	channelId,
	channelParams = {},
	encodeURIComponentForChannelId = true
) {
	const toPath = pathToRegexp.compile(channelId);
	const toPathOptions = encodeURIComponentForChannelId === false ? {encode: str => str} : {};
	return toPath(channelParams, toPathOptions);
}
